import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { TEXT_FIELD_STATUS, LOADING, ERROR, CONTEXT_PROVIDERS } from '../../utils/constants';
import EmailField from '../../components/_molecules/EmailField/EmailField';
import FullNameField from '../../components/_molecules/FullNameField/FullNameField';
import URLTextField from '../../components/_molecules/URLTextField/URLTextField';
import TimeZonePicker from '../../components/_molecules/TimeZonePicker/TimeZonePicker';
import ConnectedTextField from '../../components/_atomic/ConnectedTextField/ConnectedTextField';
import RegistrationInfoFormContext from './RegistrationInfoFormContext';
import Button from '../_atomic/Button/Button';
import LoadingOverlay from '../_molecules/LoadingOverlay/LoadingOverlay';
import ErrorModal from '../_molecules/ErrorModal/ErrorModal';
import { getFieldInitialState } from '../../utils/helpers';
import './RegistrationInfoForm.scss';


const emailFieldName = 'email';
const timeZoneFieldName = 'timezone';
const fullNameFieldName = 'fullName';
const companyNameFieldName = 'company';
const positionFieldName = 'position';
const companyWebsiteFieldName = 'website';

/* this components will be excluded at the form components, coz it has a lot of
 * common things with AuthForm, but I need time, to think about it */
class RegistrationInfoForm extends Component {
  static propTypes = {
    status: PropTypes.string.isRequired,
    annulError: PropTypes.func.isRequired,
    submitHandler: PropTypes.func.isRequired,
    error: PropTypes.string.isRequired,
    ignoreFields: PropTypes.shape({}),
    initialFieldsState: PropTypes.shape({}),
    emailSubscriptions: PropTypes.shape({}).isRequired,
  };
  static defaultProps = {
    ignoreFields: {},
    initialFieldsState: {},
  };

  constructor() {
    super();
    this.fields = {};
  }

  state = {
    fields: {
      [emailFieldName]: getFieldInitialState(),
      [fullNameFieldName]: getFieldInitialState(),
      [companyNameFieldName]: getFieldInitialState(),
      [positionFieldName]: getFieldInitialState(),
      [companyWebsiteFieldName]: getFieldInitialState(),
      [timeZoneFieldName]: getFieldInitialState(),
    },
  };
  componentWillMount() {
    const fields = { ...this.state.fields };
    const { initialFieldsState } = this.props;
    Object.keys(fields).forEach((fieldName) => {
      if (initialFieldsState[fieldName]) {
        if (fieldName === timeZoneFieldName && initialFieldsState[timeZoneFieldName] === 'UTC') {
          fields[fieldName].value = '';
        } else {
          fields[fieldName].value = initialFieldsState[fieldName];
        }
      }
    });
    this.setState(() => ({ fields }));
  }

  componentDidUpdate(prevProps) {
    const fields = { ...this.state.fields };
    const { initialFieldsState } = this.props;
    if (prevProps.initialFieldsState !== this.props.initialFieldsState) {
      Object.keys(fields).forEach((fieldName) => {
        if (fieldName === timeZoneFieldName && initialFieldsState[timeZoneFieldName] === 'UTC') {
          fields[fieldName].value = '';
        } else {
          fields[fieldName].value = initialFieldsState[fieldName];
        }
      });
      this.setState(() => ({ fields }));
    }
  }

  getFormStatus = (fields) => {
    let status = TEXT_FIELD_STATUS.INITIAL;
    const { ignoreFields } = this.props;
    let validFields = 0;
    let invalidFields = 0;
    const fieldsNames = Object.keys(fields);
    /* calc invalid fields coz form can have one VALID and one INITIAL field
       then form isn't valid or invalid it is initial */

    fieldsNames.forEach((name) => {
      if (fields[name].status === TEXT_FIELD_STATUS.VALID || ignoreFields[name]) validFields += 1;
      if (fields[name].status === TEXT_FIELD_STATUS.INVALID && !ignoreFields[name]) {
        invalidFields += 1;
      }
    });
    if (validFields === fieldsNames.length) {
      status = TEXT_FIELD_STATUS.VALID;
    }

    if (invalidFields > 0) {
      status = TEXT_FIELD_STATUS.INVALID;
    }
    return status;
  };

  fieldChangeHandler = ({ name, value }) => {
    const fields = { ...this.state.fields };
    let { formStatus } = this.state;
    fields[name].value = value;
    if (fields[name].status !== TEXT_FIELD_STATUS.INITIAL || name === timeZoneFieldName) {
      const { validator } = this.fields[name];
      const validate = validator(fields[name].value);
      fields[name].status = validate.status;
      fields[name].errorText = validate.errorText;
      formStatus = this.getFormStatus(fields);
    }

    this.setState(() => ({ fields, formStatus }));
  };

  fieldFocusHandler = ({ name, isFocused, value }) => {
    const fields = { ...this.state.fields };
    let { formStatus } = this.state;
    fields[name].isFocused = isFocused;
    fields[name].value = value;
    if (!isFocused) {
      const { validator } = this.fields[name];
      const validate = validator(fields[name].value);
      fields[name].status = validate.status;
      fields[name].errorText = validate.errorText;
      formStatus = this.getFormStatus(fields);
    }
    this.setState(() => ({ fields, formStatus }));
  };

  registerField = ({ name, validator }) => {
    this.fields[name] = {
      validator,
    };
  };

  submitHandler = (e) => {
    e.preventDefault();
    const fields = { ...this.state.fields };
    Object.keys(this.fields).forEach((name) => {
      const { validator } = this.fields[name];
      const validate = validator(fields[name].value);
      fields[name].status = validate.status;
      fields[name].errorText = validate.errorText;
    });
    const formStatus = this.getFormStatus(fields);

    this.setState(
      () => ({
        fields,
        formStatus,
      }),
      () => {
        if (formStatus === TEXT_FIELD_STATUS.VALID) {
          const data = {};
          const { emailSubscriptions } = this.props;
          Object.keys(fields).forEach((fieldName) => {
            data[fieldName] = fields[fieldName].value;
          });
          data.finance = emailSubscriptions.finance;
          data.news = emailSubscriptions.news;
          this.props.submitHandler(data);
        }
      },
    );
  };

  render() {
    const {
      status, annulError, error, ignoreFields,
    } = this.props;
    const { fields, formStatus } = this.state;
    const emailField = fields[emailFieldName];
    const fullNameField = fields[fullNameFieldName];
    const timeZoneField = fields[timeZoneFieldName];
    const companyNameField = fields[companyNameFieldName];
    const positionField = fields[positionFieldName];
    const websiteField = fields[companyWebsiteFieldName];
    const isLoading = status === LOADING;
    const isError = status === ERROR;
    const disabledButton = formStatus === TEXT_FIELD_STATUS.INVALID;
    return (
      <form onSubmit={this.submitHandler} className="add-info-form">
        <LoadingOverlay visible={isLoading} />
        <ErrorModal requestClose={annulError} visible={isError} error={error} />
        <div className="main-label">
          <span>Registration Form</span>
        </div>
        <div className="fields-wrapper">
          <RegistrationInfoFormContext.Provider
            value={{
              register: this.registerField,
              changeHandler: this.fieldChangeHandler,
              focusHandler: this.fieldFocusHandler,
            }}
          >
            {!ignoreFields.email && (
              <EmailField
                name={emailFieldName}
                value={emailField.value}
                status={emailField.status}
                isFocused={emailField.isFocused}
                errorText={emailField.errorText}
                hint={emailField.hint}
                isRequired
                contextProvider={CONTEXT_PROVIDERS.RegistrationInfoFormContext}
              />
            )}

            <FullNameField
              value={fullNameField.value}
              status={fullNameField.status}
              isFocused={fullNameField.isFocused}
              errorText={fullNameField.errorText}
              hint={fullNameField.hint}
              isRequired
              name={fullNameFieldName}
              contextProvider={CONTEXT_PROVIDERS.RegistrationInfoFormContext}
            />
            <ConnectedTextField
              value={companyNameField.value}
              status={companyNameField.status}
              isFocused={companyNameField.isFocused}
              errorText={companyNameField.errorText}
              hint={companyNameField.hint}
              isRequired
              label="Company Name"
              placeholder="Company Name"
              name={companyNameFieldName}
              errorSign
              contextProvider={CONTEXT_PROVIDERS.RegistrationInfoFormContext}
            />
            <ConnectedTextField
              value={positionField.value}
              status={positionField.status}
              isFocused={positionField.isFocused}
              errorText={positionField.errorText}
              hint={positionField.hint}
              isRequired
              errorSign
              label="Position"
              placeholder="Position"
              name={positionFieldName}
              contextProvider={CONTEXT_PROVIDERS.RegistrationInfoFormContext}
            />
            <URLTextField
              value={websiteField.value === 'null' ? 'https://' : websiteField.value}
              status={websiteField.status}
              isFocused={websiteField.isFocused}
              errorText={websiteField.errorText}
              hint={websiteField.hint}
              isRequired
              name={companyWebsiteFieldName}
              contextProvider={CONTEXT_PROVIDERS.RegistrationInfoFormContext}
            />
          </RegistrationInfoFormContext.Provider>
          <TimeZonePicker
            isRequired
            registerField={this.registerField}
            status={timeZoneField.status}
            value={timeZoneField.value}
            name={timeZoneFieldName}
            errorText={timeZoneField.errorText}
            inputProps={{
              placeholder: 'Timezone',
            }}
            onChange={this.fieldChangeHandler}
          />
        </div>
        <div className="button-wrapper">
          <Button disabled={disabledButton} label="Continue" type="submit" />
        </div>
      </form>
    );
  }
}

export default RegistrationInfoForm;



// WEBPACK FOOTER //
// ./src/components/RegistrationInfoForm/RegistrationInfoForm.js